export const unsavedChangesDialogTitle = {
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#111827',
  padding: '1.5rem 1.5rem 0.5rem 1.5rem'
} as const;

export const unsavedChangesDialogContent = {
  padding: '0 1.5rem 1.5rem 1.5rem',
  color: '#374151',
  fontSize: '1rem'
} as const;

export const unsavedChangesDialogActions = {
  padding: '1rem 1.5rem',
  borderTop: '1px solid #0000001f',
  gap: '0.75rem'
} as const;

export const discardButtonStyle = {
  backgroundColor: '#E14D2A',
  '&:hover': {
    backgroundColor: '#c8431f'
  }
} as const;
